import { DrEntity } from './dr-entity';
import { SearchType } from './enums';
import { TaskType } from './task';
import { ViewType } from './view';

export class SearchResult extends DrEntity {
    name: string;
    description: string;

    childViewCount: number;
    compareExports: any[];
    compareExportList: any[];
    createdBy: string;
    createdOn: number;
    dateCompleted: string;
    dateStarted: string;
    deDupeDocumentCount: number;
    documentCount: number;
    orderedCodeSets: any[];
    owner: string;
    priority: number;
    secondsElapsed: number;
    sourceViewHandle: any;
    taggedEntityList: any[];
    task: SearchType;
    taskType: any;
    viewType: ViewType;
    exportComparison: boolean;
    archived: boolean;

    constructor(value?: Partial<SearchResult>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
        if (this.name) {
            if (this.name.startsWith('Searching for ')) {
                this.name = this.name.replace('Searching for ', '');
            } else if (this.name.trim().startsWith('Searching ')) {
                this.name = this.name.trim().replace('Searching ', '');
            }
        }
        if (this.dateStarted) {
            this.dateStarted = this.dateStarted.replace(/\//g, '-');
        }
        if (this.dateCompleted) {
            this.dateCompleted = this.dateCompleted.replace(/\//g, '-');
        }
        if (this.taskType === TaskType.SEARCH && !this.viewType && this.attributes) {
            this.viewType = (<ViewType>this.attributes.find(a => a.name === 'viewtype')?.value);
        }
    }
}
